module.exports = __webpack_public_path__ + "img/shoushudingdan.b455b27b.png";